import { render, staticRenderFns } from "./ConfirmUnfollow.vue?vue&type=template&id=18422690&scoped=true&"
import script from "./ConfirmUnfollow.vue?vue&type=script&lang=js&"
export * from "./ConfirmUnfollow.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUnfollow.vue?vue&type=style&index=0&id=18422690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18422690",
  null
  
)

export default component.exports